export * from './registration-menu.module';
